import React from 'react';

const CartButton = (props) => {
  const { handleClick, open, itemCount, toggleMode = 'icon' } = props;

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleClick(!open);
    }
  };

  return (
    <div className="component-toggle" onClick={() => handleClick(!open)} tabIndex={0} onKeyDown={handleKeyDown}>
      {toggleMode === 'text' ? (
        <span>Cart: {itemCount}</span>
      ) : (
        <>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" className="icon icon--primary">
            <rect fill="none" width="512" height="512"></rect>
            <path
              fill="currentColor"
              d="m447.31,175.65c5.54,0,10.79,2.17,14.77,6.11,3.98,3.94,6.18,9.12,6.18,14.6v203.14c0,20.41-8.12,39.67-22.87,54.25-14.74,14.57-34.24,22.6-54.89,22.6H126.01c-20.65,0-40.14-8.03-54.89-22.6-14.74-14.57-22.87-33.84-22.87-54.25v-203.14c0-5.48,2.19-10.66,6.18-14.6,3.99-3.94,9.23-6.11,14.77-6.11h378.1m0-29.65H69.21c-28.02,0-50.95,22.66-50.95,50.36v203.14c0,58.57,48.49,106.5,107.75,106.5h264.5c59.26,0,107.75-47.92,107.75-106.5v-203.14c0-27.7-22.93-50.36-50.95-50.36h0Z"
            ></path>
            <path
              fill="currentColor"
              d="m346,95.97c-.02-49.69-40.3-89.97-90-89.97s-89.98,40.28-90,89.97h0v160.2c0,8.28,6.72,15,15,15s15-6.72,15-15V96c0-33.14,26.86-60,60-60s60,26.86,60,60v160.17c0,8.28,6.72,15,15,15s15-6.72,15-15V95.97h0Z"
            ></path>
          </svg>
          <span>{itemCount}</span>
        </>
      )}
    </div>
  );
};

export default CartButton;
